import { getToken } from "../../utils/auth";

// Client of api/crm-postventa-ficha (CrmPostventaFichaController). Same session contract as Rollo and IPC
// (crmPostventaIpcApi.js): the token travels in the X-CRM-Token header and in the body of POSTs; errors throw an Error
// with the server "mensaje", the HTTP status (400, 403, 404, 409) and the payload (a rejected save carries errores,
// field key → message).
const API_ROOT = "/api/crm-postventa-ficha";

const withTokenHeader = (token) => ({
  "Content-Type": "application/json",
  "X-CRM-Token": token || getToken() || "",
});

const handleResponse = async (response) => {
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload?.mensaje || payload?.message || "No se pudo completar la operación.");
    error.status = response.status;
    error.payload = payload;
    throw error;
  }

  return payload;
};

// Empty values are dropped; false and 0 are kept.
const buildQuery = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.set(key, value);
    }
  });

  const serialized = query.toString();
  return serialized ? `?${serialized}` : "";
};

const getJson = async (path, params) => {
  const token = getToken() || "";
  const response = await fetch(`${API_ROOT}${path}${buildQuery(params)}`, {
    method: "GET",
    headers: withTokenHeader(token),
  });

  return handleResponse(response);
};

const postJson = async (path, body = {}) => {
  const token = getToken() || "";
  const response = await fetch(`${API_ROOT}${path}`, {
    method: "POST",
    headers: withTokenHeader(token),
    body: JSON.stringify({
      token,
      ...body,
    }),
  });

  return handleResponse(response);
};

export const crmPostventaFichaApi = {
  // { clienteId, cabecera, terminales, secciones (campos with tipo EDITABLE | SOLO_LECTURA | TRAMITE and ultimoCambio),
  // versionToken, puedeEditar, ultimosCambios } of one terminal (clienteId = IdAlta), with this terminal's own values.
  obtenerFicha: async (clienteId) => getJson(`/${clienteId}`),
  // GET {clienteId}/historial?seccion&campo&usuarioId&origen(FICHA | GESTION_IPC | CRM_ANTERIOR)&desde&hasta&pagina
  // &tamanoPagina → { items, total, pagina, tamanoPagina, asesores }.
  obtenerHistorial: async (clienteId, filtros = {}) => getJson(`/${clienteId}/historial`, filtros),
  // body: { clienteId, valores (field key → value; "" clears it), versionToken, correlationId, motivo, observacion,
  // gestionId (from an open IPC Modificación gestión, finalized as Resuelta by the save) or registrarGestion
  // ({ motivoCodigo, canal }: the informal checkbox registers a gestión already Resuelta) } → { cambioId, versionToken,
  // campos, gestionId, gestionEstado }. A stale versionToken answers 409; a rejected value answers 400 with errores; a
  // gestión that cannot take the change answers 400/404/409 with its message. One correlationId per attempt makes a
  // retry idempotent.
  guardar: async ({ clienteId, valores, versionToken, correlationId, motivo, observacion, gestionId, registrarGestion } = {}) =>
    postJson("/guardar", { clienteId, valores, versionToken, correlationId, motivo, observacion, gestionId, registrarGestion }),
};
